export default __webpack_public_path__ + "37d1030179ed12778a386ba988c8f894.png";